module.exports = __webpack_public_path__ + "assets/img/logo-saules-bendruomene.8a43e854.png";